"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCart = exports.useCheckout = void 0;
const useHook_1 = require("./useHook");
exports.useCheckout = useHook_1.hookFactory("checkout");
exports.useCart = useHook_1.hookFactory("cart");
//# sourceMappingURL=hooks.js.map